var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M13.417 6.844V1H4.563C3.973 1 3.5 1.46 3.5 2.031V21.97c0 .57.474 1.03 1.063 1.03h14.875c.588 0 1.062-.46 1.062-1.031V7.875h-6.02c-.585 0-1.063-.464-1.063-1.031zm-7.084-2.75a.35.35 0 01.354-.344h3.542c.196 0 .354.154.354.344v.687c0 .19-.158.344-.354.344H6.688a.35.35 0 01-.355-.344v-.687zm0 2.75a.35.35 0 01.354-.344h3.542c.196 0 .354.154.354.344v.687c0 .19-.158.344-.354.344H6.688a.35.35 0 01-.355-.344v-.687zM14.87 17.5h2.09c.39 0 .708.308.708.688 0 .38-.317.687-.709.687H14.87a1.91 1.91 0 01-1.71-1.025.493.493 0 00-.45-.28.485.485 0 00-.444.266l-.34.659a.71.71 0 01-.683.377.703.703 0 01-.622-.468l-.745-2.168-.47 1.37c-.26.759-.99 1.269-1.815 1.269h-.548a.698.698 0 01-.709-.688c0-.38.317-.687.709-.687h.548a.494.494 0 00.471-.33l.806-2.347c.146-.421.55-.705 1.008-.705.458 0 .862.283 1.008.705l.615 1.79c.875-.696 2.392-.418 2.921.608.09.174.264.279.45.279zm5.32-11.988L15.856 1.3c-.2-.194-.47-.301-.753-.301h-.27v5.5H20.5v-.262c0-.27-.11-.533-.31-.726z"
  }))));
}

export default SvgFileContract;